/**
 * Native platform initialization for Lumivera mobile.
 * Only runs when the app is wrapped in Capacitor (iOS / Android).
 * Safe no-op on the web.
 */
import { Capacitor } from "@capacitor/core";

export async function initNativePlatform() {
  if (!Capacitor.isNativePlatform()) return;

  // Status bar — keep light surface, dark icons.
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Light });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#FDF5F7" });
    }
  } catch (e) {
    // Plugin not available — ignore.
  }

  // Hide splash explicitly once React is mounted (config also auto-hides).
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch (e) {
    // ignore
  }

  // Safe-area insets → CSS variables for layout padding.
  try {
    const { SafeArea } = await import("@capacitor-community/safe-area");
    await SafeArea.enable({
      config: {
        customColorsForSystemBars: true,
        statusBarColor: "#00000000",
        statusBarContent: "dark",
        navigationBarColor: "#00000000",
        navigationBarContent: "dark",
      },
    });
  } catch (e) {
    // ignore
  }
}
